import React, { useState, useEffect } from 'react';
import { array, func, bool } from 'prop-types';
import { Button, InputControlLabel, IconButton } from '@picsio/ui';
import { Close } from '@picsio/icons';
import { copyTranscript } from '../../utils';
import * as utils from '../../../../shared/utils';
import l18n from '../../../../shared/strings';
import Toast from '../../../Toast';
import Logger from '../../../../services/Logger';

export default function CopyTranscriptDialog({ transcript, onClose, isSettingsMode = false }) {
  const [isSpeakers, setIsSpeakers] = useState(utils.LocalStorage.get('picsio.includeSpeakerToCopyTranscript') ?? true);
  const [isTimestamps, setIsTimestamps] = useState(utils.LocalStorage.get('picsio.includeTimestampToCopyTranscript') ?? true);
  const [dontShowAgain, setDontShowAgain] = useState(utils.LocalStorage.get('picsio.dontShowAgainCopyTranscriptDialog') ?? false);

  useEffect(() => {
    Logger.log('User', 'TranscriptCopyingSettingsModalShown');
  }, []);

  const onChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'Speakers') {
      setIsSpeakers(checked);
    } else if (name === 'Timestamps') {
      setIsTimestamps(checked);
    }
  };
  const handleCopyTranscript = () => {
    Logger.log('User', 'TranscriptCopySetModalConfirmed', { display_speakers: isSpeakers, display_timestamps: isTimestamps });
    if (!isSettingsMode) {
      copyTranscript({ transcript, isSpeakers, isTimestamps });
      Toast(l18n.TRANSCRIPT.TOASTS.copyTranscript, {
        type: 'success',
      });
    }
    utils.LocalStorage.set('picsio.dontShowAgainCopyTranscriptDialog', dontShowAgain);
    utils.LocalStorage.set('picsio.includeSpeakerToCopyTranscript', isSpeakers);
    utils.LocalStorage.set('picsio.includeTimestampToCopyTranscript', isTimestamps);

    onClose();
  };

  const onChangeDontShowAgain = (e) => {
    const { checked } = e.target;
    setDontShowAgain(checked);
  };
  return (
    <div className="simpleDialog copyTranscriptDialog">
      <div className="simpleDialogUnderlayer" />
      <div className="simpleDialogBox">
        <div className="simpleDialogHeader">
          <h2 className="simpleDialogTitle">{l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.TITLE}</h2>
          <IconButton
            className="simpleDialogBtnCross"
            onClick={onClose}
            size="lg"
          >
            <Close />
          </IconButton>
        </div>
        <div className="simpleDialogContent">
          <div className="simpleDialogContentInner">
            <div className="simpleDialogDescription">
              {l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.TEXT}
            </div>
            <div className="copyTranscriptDialog__options">
              <InputControlLabel
                label={l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.CHECKBOX_SPEAKER}
                id="speakers"
                name="Speakers"
                value={isSpeakers}
                onChange={onChange}
                control="checkbox"
              />
              <InputControlLabel
                label={l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.CHECKBOX_TIMESTAMPS}
                id="timestamps"
                name="Timestamps"
                value={isTimestamps}
                onChange={onChange}
                control="checkbox"
              />
            </div>
            <If condition={!isSettingsMode}>
              <InputControlLabel
                label={l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.CHECKBOX_DONT_SHOW_AGAIN}
                id="dontShowAgain"
                name="DontShowAgain"
                value={dontShowAgain}
                onChange={onChangeDontShowAgain}
                control="checkbox"
              />
            </If>

          </div>
        </div>
        <div className="simpleDialogFooter">
          <Button
            color="secondary"
            size="md"
            variant="contained"
            onClick={onClose}
          >
            {l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.BTN_CANCEL}
          </Button>
          <Button
            color="primary"
            size="md"
            variant="contained"
            onClick={handleCopyTranscript}
          >
            {l18n.TRANSCRIPT.DIALOG_COPY_SETTINGS.BTN_OK(isSettingsMode)}
          </Button>
        </div>
      </div>
    </div>

  );
}

CopyTranscriptDialog.propTypes = {
  transcript: array.isRequired,
  onClose: func.isRequired,
  isSettingsMode: bool,
};
